// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preloader-wrap{width:50%;height:400px;display:flex;justify-content:center;align-items:center;align-content:center;border:1px solid silver}\n", ""]);
// Exports
module.exports = exports;
